import { ChevronLeftIcon } from '@heroicons/react/24/solid';

interface IProps {
    onClick: VoidFunction;
}

export const BackButtonRounded = ({ onClick }: IProps) => {
    return (
        <button
            className={'relative w-10 h-10 border border-neutral-500 rounded-full bg-neutral-600 shrink-0 hover:bg-neutral-500 transition'}
            onClick={onClick}
        >
            <ChevronLeftIcon
                className={'absolute w-7 h-7 top-1/2 left-1/2 translate-x-[-55%] -translate-y-1/2'} />
        </button>
    );
};